module.exports = __webpack_public_path__ + "979c0f6c7628c2f3abfa8b6faef9dfe6.svg";